var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconActivityStepsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02283 5.3342L4.94143 5.16266C4.65653 4.69093 4.49373 4.04766 4.45303 3.3615C4.37162 1.77476 4.94143 0.531083 5.83684 0.445312H5.87753C6.69154 0.445312 7.42415 1.56033 7.54625 3.10419C7.58695 3.79035 7.50555 4.43362 7.30204 4.94824L7.26135 5.11978H7.09854C6.81364 5.07689 6.44734 5.07689 6.16244 5.11978C5.83684 5.11978 5.51124 5.20556 5.22633 5.29133L5.02283 5.3342Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97717 4.88889L3.05857 4.71735C3.34347 4.24562 3.50627 3.60235 3.54697 2.91619C3.62838 1.32944 3.05857 0.08577 2.16316 0H2.12247C1.30846 0 0.575852 1.11502 0.453751 2.65888C0.413051 3.34504 0.494454 3.98831 0.697955 4.50293L0.738652 4.67446H0.901457C1.18636 4.63158 1.55266 4.63158 1.83756 4.67446C2.16316 4.67446 2.48876 4.76024 2.77367 4.84601L2.97717 4.88889Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99791 7.99957C5.32466 7.99957 4.84942 7.18476 4.88902 6.22179C4.88902 6.14772 4.88902 6.0366 4.88902 5.96253L4.92863 5.77734L7.1068 5.85142V6.03661C7.1068 6.11068 7.1068 6.22179 7.1068 6.29586C7.1464 7.25882 6.63156 7.99957 5.99791 7.99957Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99818 7.55425C2.67144 7.55425 3.14667 6.73944 3.10707 5.77648C3.10707 5.70241 3.10707 5.59129 3.10707 5.51722L3.06747 5.33203L0.889295 5.40611V5.5913C0.889295 5.66537 0.889295 5.77647 0.889295 5.85055C0.849691 6.81351 1.36453 7.55425 1.99818 7.55425Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActivityStepsWhite);
export default __webpack_public_path__ + "static/media/icon-activity-steps-white.42de2b4f4f51f4c73c65ab892cf45fbb.svg";
export { ForwardRef as ReactComponent };